import React from 'react';
import { Form } from 'components/form/Form';
import { Fieldset } from 'components/form/Fieldset';
import { Textbox } from 'components/form/Textbox';
import { Select } from 'components/form/Select';
import { Checkbox } from 'components/form/Checkbox';

export const Component = () => {
  return (
    <Form
      tagline="Form tagline"
      title="Form title"
      text={
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
          ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation
          ullamco laboris nisi ut aliquip ex ea commodo consequat.
        </p>
      }
      isSlice
    >
      <Textbox id="textbox" name="textbox" label="Textbox" placeholder="Placeholder" />

      <Select
        id="select"
        name="textbox"
        label="Select"
        placeholder="Placeholder"
        options={['first option', 'second option']}
      />

      <Checkbox
        name="checkbox"
        id="checkbox1"
        label="Please check here to confirm that you are 16-years of age or older"
      />

      <Fieldset legend="Radio buttons">
        <Checkbox type="radio" name="radio" id="radio1" label="Radio button one" />
        <Checkbox type="radio" name="radio" id="radio2" label="Radio button two" />
      </Fieldset>
    </Form>
  );
};
